export const valueFormat = (value) => {
  if (value || value === 0) {
    return value;
  } else {
    return "-";
  }
};
